import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGiftsMaster } from "../../store/giftcards/reducer";
import { REQUEST_DELETE_MASTER_GIFTS } from "../../store/giftcards/giftcardsActionTypes";
import axios from "axios";
interface HelpCenterDeleteProps {
  helpData: any;
  isOpen: boolean;
  onClose: () => void;
  selectedTab?: any;
  onDeleteSuccess: () => void;
}

const HelpCenterDeleteConfirmation: React.FC<HelpCenterDeleteProps> = ({
  isOpen,
  onClose,
  helpData,
  selectedTab,
  onDeleteSuccess,
}) => {
  const dispatch = useDispatch();
  // const { masterGifts: events, busy, message } = useGiftsMaster();
  const [isDeleting, setIsDeleting] = useState(false);

  const toast = useToast();

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      let endpoint = "";

      switch (selectedTab) {
        case "bugReport":
          endpoint = "bug-report";
          break;
        case "feedback":
          endpoint = "feedback";
          break;
        case "contactUs":
          endpoint = "contact-us";
          break;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/admin/${endpoint}/${helpData._id}`
      );

      if (response.data) {
        toast({
          title: "Deleted successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onDeleteSuccess();
        onClose();
      }
    } catch (error) {
      toast({
        title: "Error deleting item",
        description: "Please try again",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Theme</ModalHeader>
        <ModalCloseButton disabled={isDeleting} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this theme?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={onClose}
            disabled={isDeleting}
          >
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            isLoading={isDeleting}
            disabled={isDeleting}
            // onClick={() => {
            //   dispatch({
            //     type: REQUEST_DELETE_MASTER_GIFTS,
            //     payload: { _id: event.key },
            //   });
            // }}
            onClick={handleDelete}
          >
            Submit
          </Button>
        </ModalFooter>
        {/* {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )} */}
      </ModalContent>
    </Modal>
  );
};

export default HelpCenterDeleteConfirmation;
